import { useEffect } from 'react';
import { Col, Form, Row } from 'antd';

import FormInputNumber from '@/views/components/Inputs/FormInputNumber';

import FormInput from '../../../../../components/Inputs/FormInput';
import HiddenFormInput from '../../../../../components/Inputs/HiddenFormInput';
import Paper from '../../../../../components/Paper/Paper';
import ClaimsChargeSelector from '../../../../../components/Selectors/ClaimsChargeSelector';
import SaveCancelButtons from '../../../../Shipment/components/SaveCancelButtons';

const LADSettlementCard = ({
  editMode = false,
  isLastItem = false,
  shadowVisible = true,
  index = 0,
  settlementDetails,
  setEditMode,
  handleCancel,
  handleSubmit,
  handleDelete,
  onFieldChange,
}) => {
  const [form] = Form.useForm();

  const initialValues = {
    ...settlementDetails,
    amount: settlementDetails?.amount != null ? Number(settlementDetails.amount) : undefined,
  };

  useEffect(() => {
    if (settlementDetails) {
      const formValues = {
        ...settlementDetails,
        amount:
          settlementDetails?.amount != null && settlementDetails.amount !== ''
            ? Number(settlementDetails.amount)
            : undefined,
      };
      form.setFieldsValue(formValues);
    }
  }, [settlementDetails, form]);
  return (
    <Paper className={`border-muted ${!isLastItem ? 'mb-16' : ''} ${shadowVisible ? '' : 'shadow-none'}`}>
      <Form
        key={`${settlementDetails?.settlementSeq}-${settlementDetails?.amount}-${settlementDetails?.accountingCode}-${settlementDetails?.chargeCode}`}
        onFinish={(data) => handleSubmit(data, index)}
        onValuesChange={onFieldChange}
        form={form}
        initialValues={initialValues}
      >
        <div className="pt-8 pb-10 px-16" style={{ minHeight: '130px' }}>
          <Row justify="space-between" gutter={30}>
            <Col sm={6}>
              <ClaimsChargeSelector
                editMode={editMode}
                margin="mb-0"
                name="chargeCode"
                rules={[
                  {
                    message: 'Please enter Charge Code',
                    required: true,
                  },
                ]}
              />
            </Col>
            <Col sm={6}>
              <FormInput
                label="Accounting Code"
                placeholder="Enter Accounting Code"
                margin="mb-0"
                name="accountingCode"
                editMode={editMode}
                maxLength={26}
              />
            </Col>
            <Col sm={6}>
              <FormInputNumber
                label="Amount"
                placeholder="Enter Amount"
                margin="mb-0"
                name="amount"
                editMode={editMode}
                validateTrigger={['onChange', 'onBlur']}
                rules={[
                  {
                    message: 'Please enter Amount',
                    required: true,
                  },
                ]}
                inputType="number"
                allowNegative
              />
            </Col>
            <Col className="flex-1">
              <Row align="middle" justify="end">
                <Col>
                  <SaveCancelButtons
                    editMode={editMode}
                    lightMode={false}
                    setEditMode={(val) => setEditMode(index, val)}
                    handleRemove={() => handleDelete(index)}
                    isNew={settlementDetails.isNew}
                    idSuffix={`product-details-${index + 1}`}
                    isModified
                    onCancel={() => handleCancel(index, settlementDetails.isNew)}
                  />
                </Col>
              </Row>
            </Col>
          </Row>
        </div>
        <HiddenFormInput name="settlementSeq" />
        <HiddenFormInput name="isNew" />
        <HiddenFormInput name="editMode" />
        <HiddenFormInput name="claimKey" />
      </Form>
    </Paper>
  );
};

export default LADSettlementCard;
